import React, { useState } from "react";
import { api } from "./api";

const RAZORPAY_KEY_ID = "rzp_test_YourTestKeyHere"; // Replace with your Razorpay test key

const Subscribe = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const company_id = urlParams.get("company_id");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRazorpay = async () => {
    setLoading(true);
    setMessage("");
    // For demo, let's say the plan is always 100 INR
    const amount = 100 * 100; // Razorpay works in paise

    const options = {
      key: RAZORPAY_KEY_ID,
      amount: amount,
      currency: "INR",
      name: "AECP Subscription",
      description: "1 Year Premium Plan",
      handler: async function (response) {
        // On payment success, call your backend to activate subscription
        try {
          const res = await api.post("subscriptionRenewal.php", {
            company_id,
            subscription_plan: "premium",
            duration_days: 365,
            razorpay_payment_id: response.razorpay_payment_id,
          });
          if (res.data.status === "success") {
            setMessage("Subscription successful! You can now log in.");
          } else {
            setMessage(res.data.message || "Subscription failed.");
          }
        } catch (err) {
          setMessage("Network error. Please try again.");
        }
        setLoading(false);
      },
      prefill: {
        email: "", // Optionally prefill user email
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 400, margin: "100px auto", padding: 24, background: "#fff", borderRadius: 8 }}>
      <h2>Subscribe to a Plan</h2>
      <div>
        <b>Premium (1 year): ₹100 (Test Mode)</b>
      </div>
      <button onClick={handleRazorpay} disabled={loading} style={{ marginTop: 16 }}>
        {loading ? "Processing..." : "Pay & Subscribe"}
      </button>
      {message && <div style={{ marginTop: 16, color: message.includes("success") ? "green" : "red" }}>{message}</div>}
    </div>
  );
};

export default Subscribe; 
